/*
 * Equipment Detail Container
 */

import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { selectIsLoading } from '../../reducers/commonReducers';
import { IinitialState } from '../../reducers';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import EquipmentDetail from './EquipmentDetail';
import { selectSelectedFacilityID } from '../../reducers/facilitiesReducer';

const mapStateToProps = (
    state: IinitialState,
    ownProps: WithTranslation & RouteComponentProps<{ installID: string }>
) => {
    const installID = ownProps.match.params.installID;
    const installBase = state.manageInventory.installBasesByID[installID];

    return {
        installBase,
        loading: selectIsLoading(state),
        selectedFacilityID: selectSelectedFacilityID(state)
    };
};

export const EquipmentDetailContainer = withRouter(
    connect(mapStateToProps)(withTranslation()(EquipmentDetail))
);
